import React from 'react';
import classNames from 'classnames';
import { FieldRenderProps } from 'react-final-form';
import { Toggle } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './ToggleField.styles.scss';

type ToggleFieldProps = FieldRenderProps<boolean, HTMLElement> &
  FieldWrapperProps & {
    customOnChange?: (value: boolean) => void;
  };

const ToggleField: React.FC<ToggleFieldProps> = (props) => {
  const {
    className,
    input: { value, checked, onChange, ...restInput },
    onContent,
    offContent,
    customOnChange,
    ...rest
  } = props;
  const { t } = useTranslation();

  const classes = classNames('toggle-field', className);

  const handleOnChange = ({
    target: { checked },
  }: React.ChangeEvent<HTMLInputElement>) => {
    onChange(checked);
    customOnChange?.(checked);
  };

  return (
    <FieldWrapper className={classes} {...rest}>
      <Toggle
        onContent={onContent || <p>{t('yes')}</p>}
        offContent={offContent || <p>{t('no')}</p>}
        onChange={handleOnChange}
        checked={checked}
        {...restInput}
        {...rest}
      />
    </FieldWrapper>
  );
};

export default ToggleField;
